import apiService from './apiService';

const AFFILIATE_TOKEN_KEY = 'affiliate_token';

/**
 * Service pour les liens de partage affilié
 */
class ShareLinkService {
  /**
   * Génère un lien de partage pour un produit.
   * Utilise le token du client connecté pour que `shared_by` soit
   * correctement renseigné côté backend (sinon la commission n'est
   * pas attribuée au bon affilié).
   * @param {string} productId - L'ID du produit (UUID)
   * @returns {Promise<{affiliate_link: string}>}
   */
  async generateShareLink(productId) {
    const response = await apiService.get(`/products/share-link/${productId}`);
    return response.data || response;
  }

  /**
   * Résout un lien de partage et retourne le token + lien long
   * @param {string} shareCode - Le code du lien de partage
   * @returns {Promise<{data: {token: string, long_link: string}}>}
   */
  async resolveShareLink(shareCode) {
    const response = await apiService.get(`/s/${shareCode}`);
    return response.data;
  }

  /**
   * Extrait le code de partage depuis un affiliate_link API
   * Ex: "https://dev.api.chinexpress.com/api/s/abc123" → "abc123"
   * @param {string} affiliateLink - Le lien retourné par l'API
   * @returns {string} Le code de partage
   */
  extractShareCode(affiliateLink) {
    const parts = affiliateLink.split('/s/');
    return parts.length > 1 ? parts[parts.length - 1] : affiliateLink;
  }

  /**
   * Construit le lien de partage front-end à partir du lien API
   * @param {string} affiliateLink - Le lien retourné par l'API
   * @returns {string} Le lien front-end (ex: https://yiatou.com/s/abc123)
   */
  buildFrontShareUrl(affiliateLink) {
    const code = this.extractShareCode(affiliateLink);
    return `${window.location.origin}/s/${code}`;
  }

  /**
   * Stocke le token d'affiliation dans localStorage
   * @param {string} token
   */
  setAffiliateToken(token) {
    if (token) {
      localStorage.setItem(AFFILIATE_TOKEN_KEY, token);
    }
  }

  /**
   * Récupère le token d'affiliation depuis localStorage
   * @returns {string|null}
   */
  getAffiliateToken() {
    return localStorage.getItem(AFFILIATE_TOKEN_KEY);
  }

  /**
   * Supprime le token d'affiliation du localStorage
   */
  clearAffiliateToken() {
    localStorage.removeItem(AFFILIATE_TOKEN_KEY);
  }
}

const shareLinkServiceInstance = new ShareLinkService();
export default shareLinkServiceInstance;
